var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<ul class=\"confirmation-summary\">\n<li class=\"row confirmation-summary-item\" ng-repeat=\"answer in $questionAnswersListCtrl.answers\">\n<div class=\"col-xs-3\">{{answer.question_text | bookingQuestionName}}</div>\n<div class=\"col-xs-9\" ng-if=\"answer.question.detail_type == 'date'\">\n{{answer.value | datetime: 'LLLL'}}\n</div>\n<div class=\"col-xs-9\" ng-if=\"answer.question.detail_type && answer.question.detail_type != 'date'\">\n{{answer.value}}\n</div>\n</li>\n</ul>";
var id1="javascripts/question-answers-list/question_answers_list.template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/javascripts/question-answers-list/question_answers_list.template.html
// module id = 1316
// module chunks = 0